import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Target, BookOpen, MapPin, Brain, PenTool, Search, Sparkles } from 'lucide-react';
import { Card } from '../shared/Card';
import { Button } from '../shared/Button';

const quickActions = [
  {
    title: 'AI Essay Editor',
    description: 'Get real-time feedback on your essays',
    icon: PenTool,
    color: 'primary' as const,
    action: () => window.location.href = '/essays',
    badge: 'AI'
  },
  {
    title: 'Find Research',
    description: 'Discover research opportunities matched to you',
    icon: Search,
    color: 'secondary' as const,
    action: () => window.location.href = '/research',
    badge: 'AI'
  },
  {
    title: 'Add Activity',
    description: 'Log a new extracurricular activity',
    icon: Plus,
    color: 'accent' as const,
    action: () => window.location.href = '/activities',
  },
  {
    title: 'AI Hub',
    description: 'Explore all AI-powered features',
    icon: Brain,
    color: 'primary' as const,
    action: () => window.location.href = '/ai-hub',
    badge: 'NEW'
  },
];

export const QuickActions: React.FC = () => {
  return (
    <Card>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {quickActions.map((action, index) => {
          const Icon = action.icon;
          return (
            <motion.div
              key={action.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <Button
                variant="ghost"
                className="w-full h-auto p-4 flex flex-col items-start text-left space-y-2 hover:bg-gray-50 border border-gray-200 hover:border-gray-300 relative"
                onClick={action.action}
              >
                <div className="flex items-center space-x-3 w-full">
                  <div className={`p-2 rounded-lg bg-${action.color}-100 text-${action.color}-600 group-hover:scale-110 transition-transform`}>
                    <Icon size={16} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-medium text-gray-900 flex items-center gap-2">
                      {action.title}
                      {action.badge && (
                        <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${
                          action.badge === 'AI'
                            ? 'bg-gradient-to-r from-primary-500 to-accent-500 text-white'
                            : 'bg-green-100 text-green-800'
                        }`}>
                          {action.badge === 'AI' && <Sparkles size={10} className="inline mr-1" />}
                          {action.badge}
                        </span>
                      )}
                    </h4>
                    <p className="text-sm text-gray-500">{action.description}</p>
                  </div>
                </div>
              </Button>
            </motion.div>
          );
        })}
      </div>
    </Card>
  );
};